<template>
    <div>Base</div>
</template>

<script>
	import ProgramStep from "@shared/Program/ProgramStep/ProgramStep";
	import CoachingProgram from "@/core/js/model/Program/CoachingProgram";

	import BaseComponent from "@/core/components/BaseComponent.vue";

	export default {
		extends: BaseComponent,
        name: "BaseRow",
		props:{
			program: {type: CoachingProgram, default: null},
			programStep: {type: ProgramStep, default: null},
			clientsCount: {type: Number, default: null},
			itemIndex: {type: Number, default: -1},
			sectionIndex: {type: Number, default: -1},
			isInCoachMode: {type: Boolean, default: true},
			isInClientMode: {type: Boolean, default: true},
			isEditable: {type: Boolean, default: false},
			isDraggable: {type: Boolean, default: true},
		},
		data(){
        	return{
				mouseHoverItemIndex: -1
			}
		},
		methods:{
			isItemChecked(task, index, itemIndex){
				let pathNumber = this.indexPathToNumber(index, itemIndex);
				let res = this.mouseHoverItemIndex == pathNumber || this.isCompletedByCurrentUser(task)
				return res;
			},
			isCompletedByCurrentUser(task){
				return task.isCompletedBy(this.currentUser.uid)
			},
			indexPathToNumber(index, itemIndex){
				return index * 100000 + itemIndex;
			},
			isItemCompleted(task){
				return task.isCompletedBy(this.currentUser.uid);
			},
			isItemCompletedCoach(task){
				return task.isCompleted();
			},
			notifyItemToggleCompletion(item){
				console.log("notifyItemToggleCompletion row: item = ", item)
				this.$emit("onItemCompletionToggleRow", item)
			},
		},
		computed:{
			isEditableVal(){
				return this.isInCoachMode || this.isEditable
			}
		}


	}
</script>

<style src="../GrabbableStyle.scss" lang="scss"/>

<style>


</style>


